export default {
  title: 'Manager data'
}
